import _ from 'lodash';
import PipsItem from '../PipsItem/PipsItem';
import React, { Component, Fragment } from 'react';
import { checkIfFull, getPipeStep } from '@ro-utils/common/slider';
import { getHour } from '@ro-sources/calendar';
import { Props } from './PipsInner.types';
import { RADAR_FORMAT } from '@ro-utils/constant';
import { withTimezone } from '@ro-utils/common/radar-params';

class PipsInner extends Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    return nextProps.slide !== this.props.slide;
  }
  render() {
    const { slide } = this.props;
    return (
      <Fragment>
        {_.times(slide.pip_length, (i: number) => {
          const time = slide.sliderdata[slide.min + i];
          const hours = getHour(withTimezone(time, RADAR_FORMAT));
          const hourAsNumber = parseFloat(hours.split(':')[0]);
          const pipsStep = getPipeStep(parseInt((window.innerWidth / 47).toFixed(0), 10), slide.max / 6);
          return (
            time && (
              <PipsItem key={`pip${i}`} fullHour={checkIfFull(hours)} inStep={hourAsNumber % pipsStep === 0}>
                {hours}
              </PipsItem>
            )
          );
        })}
      </Fragment>
    );
  }
}
export default PipsInner;
